import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Button,
    Link,
    useDisclosure,
    HStack, Image
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { RxHamburgerMenu } from "react-icons/rx";
import LoginModal from '../Login/LoginModal'
import ProfileModal from '../User/UserProfileModal'

const MenuBar = ({ setUser }) => {
    const loginDisclosure = useDisclosure();
    const profileDisclosure = useDisclosure();
    const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('authToken'));

    const [user, setLocalUser] = useState(() => {
        const saved = localStorage.getItem('authUser');
        return saved ? JSON.parse(saved) : null;
    });

    const companyName = user ? user.company?.companyName : ''

    const logoUrl = user?.company?.logoUrl
        ? `${process.env.REACT_APP_BACKEND_URL}/api/auth/test-route?img=${user.company.logoUrl}`
        : '';

    const handleLogout = () => {
        localStorage.removeItem('authToken');
        localStorage.removeItem('authUser');
        window.location.reload();
    };

    return (
        <>
            <HStack spacing={4}>
                {!isLoggedIn && (
                    <Button variant="solid-green-btn" fontWeight={600} onClick={loginDisclosure.onOpen}>
                        Trader's Account
                    </Button>
                )}
                {isLoggedIn && (

                    <Button
                        onClick={profileDisclosure.onOpen}
                        variant="outline"
                        fontWeight={600}
                        display="flex"
                        alignItems="center"
                        gap={2}
                        px={3}
                    >
                        {logoUrl && (
                            <Image
                                src={logoUrl}
                                alt="Company Logo"
                                boxSize="30px"
                                borderRadius="full"
                                objectFit="cover"
                            />
                        )}
                        {companyName.length > 6 ? companyName.slice(0, 6) + '...' : companyName}
                    </Button>
                )}

                <Menu >
                    <MenuButton as={Button} background={'transparent'}>
                        <RxHamburgerMenu color='#000' />
                    </MenuButton>
                    <MenuList zIndex={20} color={'black.100'} border={'none'}>
                        <MenuItem as={Link} href='https://www.spacephoto.co.uk/about-space-photo/'>About Us</MenuItem>
                        <MenuItem as={Link} href='https://www.spacephoto.co.uk/products-services/'>Products And Services</MenuItem>
                        <MenuItem as={Link} href='https://www.spacephoto.co.uk/portfolios/'>Portfolio</MenuItem>
                        <MenuItem as={Link} href='/'>Shop</MenuItem>
                        <MenuItem as={Link} href='https://www.spacephoto.co.uk/blog/'>Blog</MenuItem>
                        <MenuItem as={Link} href='https://www.spacephoto.co.uk/contact-us/'>Contact Us</MenuItem>
                        {isLoggedIn && (
                            <MenuItem onClick={handleLogout}>Logout</MenuItem>
                        )}
                    </MenuList>
                </Menu>
            </HStack>

            <LoginModal
                isOpen={loginDisclosure.isOpen}
                onClose={loginDisclosure.onClose}
                setIsLoggedIn={setIsLoggedIn}
                setUser={(u) => {
                    setUser(u)
                    setLocalUser(u)
                }}
            />
            <ProfileModal
                isOpen={profileDisclosure.isOpen}
                onClose={profileDisclosure.onClose}
                user={user}
                setUser={(u) => {
                    setUser(u)
                    setLocalUser(u)
                }}
            />
        </>
    )
}

export default MenuBar
